import React, { FC, useCallback, useRef, useState } from 'react';
import { setTimeout } from 'timers';
import { isMobileOrTablet } from '../../utils/helpers/mediaQueries';

import styles from './interceptedLi.module.scss';

type InterceptedLiPropTypes = {
    handledElementId: string;
    children: any;
};

const InterceptedLi: FC<InterceptedLiPropTypes> = ({ children, handledElementId, ...props }) => {
    const [lastIntersectedSide, setLastIntersectedSide] = useState('left');

    const handleMouseOver = (e: React.MouseEvent<any>) => {
        if (!isMobileOrTablet()) {
            const side = (e.target as HTMLDivElement).dataset.side;
            const handledElement = document.getElementById(handledElementId);
            if (side && handledElement) {
                handledElement.classList.remove(
                    styles['animation-top-in'],
                    styles['animation-bottom-in'],
                    styles['animation-left-in'],
                    styles['animation-right-in'],
                    styles['animation-left-out'],
                    styles['animation-right-out'],
                    styles['animation-top-out'],
                    styles['animation-bottom-out'],
                );
                handledElement.classList.add(styles[`animation-${side}-in`]);
            }
        }
    };

    const handleMouseLeave = (e: React.MouseEvent<any>) => {
        if (!isMobileOrTablet()) {
            const handledElement = document.getElementById(handledElementId);
            if (handledElement) {
                handledElement.classList.remove(
                    styles['animation-top-in'],
                    styles['animation-bottom-in'],
                    styles['animation-left-in'],
                    styles['animation-right-in'],
                );
                handledElement.classList.add(styles[`animation-${lastIntersectedSide}-out`]);
            }
        }
    };

    const handleClick = (e: React.MouseEvent<any>) => {
        if (isMobileOrTablet()) {
            const handledElement = document.getElementById(handledElementId);
            if (handledElement) {
                if (handledElement.classList.value.includes('animation-top-in')) {
                    handledElement.classList.remove(styles['animation-top-in'], styles['animation-top-out']);
                    handledElement.classList.add(styles['animation-top-out']);
                } else {
                handledElement.classList.remove(styles['animation-top-in'], styles['animation-top-out']);
                handledElement.classList.add(styles[`animation-top-in`]);
            }
            }
        }
    };

    return (
        <li
            className={styles.itemWrapper}
            {...props}
            onMouseEnter={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
        >
            <div className={styles.interceptor} data-side='top' onMouseEnter={() => setLastIntersectedSide('top')} />
            <div className={styles.interceptor} data-side='bottom' onMouseEnter={() => setLastIntersectedSide('bottom')} />
            <div className={styles.interceptor} data-side='left' onMouseEnter={() => setLastIntersectedSide('left')} />
            <div className={styles.interceptor} data-side='right' onMouseEnter={() => setLastIntersectedSide('right')} />
            {children}
        </li>
    );
};

export default InterceptedLi;